module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAeCAMAAAASJ24jAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUxpcf///////////////////////////////////////////////////////////////////6Sl3sMAAAARdFJOUwAd5kaPrTvu/eccxrYLhu0IOT3DOAAAAFdJREFUGNPNkUsOgDAIRFHb0tbv3P+yhoa0wtK4cFa8lzAhgUiTYskAWPEKQhIVATAiZSdiZ+0oMm8T9bSNOpie/S8Ew2Qmy1i9OLxYXMe5f3LYvwWPF92+hQ55DDBM0QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expanded-project-responsive-path-3@2x.png
// module id = 167
// module chunks = 0